import React from "react";
import Loadable from "react-loadable";

import { WholePageLoader } from "@exovera/loading-spinner";

const Loading = (props) => {
	if (props.error) {
		console.error("Loading Error", props.error);
		return <WholePageLoader />;
	} else {
		return <WholePageLoader />;
	}
};

// A separate setup loader per project. This sets the API endpoints.
// Loading them dynamically should theoretically be more secure

const BalticsDemoSetupLoader = Loadable.Map({
	loader: {
		SetupComponent: () => import(/* webpackChunkName: "setup" */ "layout/Setup"),
		api: () => import(/* webpackChunkName: "setup" */ "lib/api/balticsDemoApi.js"),
	},
	loading: Loading,
	render(loaded, props) {
		const Setup = loaded.SetupComponent.default;
		const api = loaded.api.default;
		return <Setup api={api} />;
	},
});

const BCBSSetupLoader = Loadable.Map({
	loader: {
		SetupComponent: () => import(/* webpackChunkName: "setup" */ "layout/Setup"),
		api: () => import(/* webpackChunkName: "setup" */ "lib/api/bcbsApi.js"),
		customLogo: () => import(/* webpackChunkName: "setup" */ "assets/images/svg/calibrate.svg"),
		projectTheme: () => import(/* webpackChunkName: "setup" */ "config/projectVars/sevenTwenty.js"),
	},
	loading: Loading,
	render(loaded, props) {
		const Setup = loaded.SetupComponent.default;
		const api = loaded.api.default;
		const logo = loaded.customLogo.default;
		const theme = loaded.projectTheme.default;
		return <Setup api={api} customLogo={logo} projectTheme={theme} />;
	},
});

const DcccSetupLoader = Loadable.Map({
	loader: {
		SetupComponent: () => import(/* webpackChunkName: "setup" */ "layout/Setup"),
		api: () => import(/* webpackChunkName: "setup" */ "lib/api/bcbsApi.js"),
		customLogo: () => import(/* webpackChunkName: "setup" */ "assets/images/svg/calibrate.svg"),
		projectTheme: () => import(/* webpackChunkName: "setup" */ "config/projectVars/sevenTwenty.js"),
	},
	loading: Loading,
	render(loaded, props) {
		const Setup = loaded.SetupComponent.default;
		const api = loaded.api.default;
		const logo = loaded.customLogo.default;
		const theme = loaded.projectTheme.default;
		return <Setup api={api} customLogo={logo} projectTheme={theme} />;
	},
});

const CBPSetupLoader = Loadable.Map({
	loader: {
		SetupComponent: () => import(/* webpackChunkName: "setup" */ "layout/Setup"),
		api: () => import(/* webpackChunkName: "setup" */ "lib/api/cbpApi.js"),
	},
	loading: Loading,
	render(loaded, props) {
		const Setup = loaded.SetupComponent.default;
		const api = loaded.api.default;
		return <Setup api={api} />;
	},
});

const GECSetupLoader = Loadable.Map({
	loader: {
		SetupComponent: () => import(/* webpackChunkName: "setup" */ "layout/Setup"),
		customLogo: () => import(/* webpackChunkName: "setup" */ "assets/images/double_logo.png"),
		api: () => import(/* webpackChunkName: "setup" */ "lib/api/gecApi.js"),
	},
	loading: Loading,
	render(loaded, props) {
		const Setup = loaded.SetupComponent.default;
		const api = loaded.api.default;
		const logo = loaded.customLogo.default;
		return <Setup api={api} customLogo={logo} />;
	},
});

const GECAnaystSetupLoader = Loadable.Map({
	loader: {
		SetupComponent: () => import(/* webpackChunkName: "setup" */ "layout/Setup"),
		customLogo: () => import(/* webpackChunkName: "setup" */ "assets/images/double_logo.png"),
		api: () => import(/* webpackChunkName: "setup" */ "lib/api/gecApi.js"),
	},
	loading: Loading,
	render(loaded, props) {
		const Setup = loaded.SetupComponent.default;
		const api = loaded.api.default;
		const logo = loaded.customLogo.default;
		return <Setup api={api} customLogo={logo} />;
	},
});

const GECDevSetupLoader = Loadable.Map({
	loader: {
		SetupComponent: () => import(/* webpackChunkName: "setup" */ "layout/Setup"),
		customLogo: () => import(/* webpackChunkName: "setup" */ "assets/images/double_logo.png"),
		api: () => import(/* webpackChunkName: "setup" */ "lib/api/gecDevApi.js"),
	},
	loading: Loading,
	render(loaded, props) {
		const Setup = loaded.SetupComponent.default;
		const api = loaded.api.default;
		const logo = loaded.customLogo.default;
		return <Setup api={api} customLogo={logo} />;
	},
});

const MidtermsSetupLoader = Loadable.Map({
	loader: {
		SetupComponent: () => import(/* webpackChunkName: "setup" */ "layout/Setup"),
		api: () => import(/* webpackChunkName: "setup" */ "lib/api/midterms.js"),
		customLogo: () => import(/* webpackChunkName: "setup" */ "assets/images/svg/calibrate.svg"),
		projectTheme: () => import(/* webpackChunkName: "setup" */ "config/projectVars/sevenTwenty.js"),
	},
	loading: Loading,
	render(loaded, props) {
		const Setup = loaded.SetupComponent.default;
		const api = loaded.api.default;
		const logo = loaded.customLogo.default;
		const theme = loaded.projectTheme.default;
		return <Setup api={api} customLogo={logo} projectTheme={theme} />;
	},
});

const UsccSetupLoader = Loadable.Map({
	loader: {
		SetupComponent: () => import(/* webpackChunkName: "setup" */ "layout/Setup"),
		api: () => import(/* webpackChunkName: "setup" */ "lib/api/uscc23Api.js"),
	},
	loading: Loading,
	render(loaded, props) {
		const Setup = loaded.SetupComponent.default;
		const api = loaded.api.default;
		return <Setup api={api} />;
	},
});

const DemoSetupLoader = Loadable.Map({
	loader: {
		SetupComponent: () => import(/* webpackChunkName: "setup" */ "layout/Setup"),
		api: () => import(/* webpackChunkName: "setup" */ "lib/api/demoApi.js"),
	},
	loading: Loading,
	render(loaded, props) {
		const Setup = loaded.SetupComponent.default;
		const api = loaded.api.default;
		return <Setup api={api} />;
	},
});

const SevenTwentyLoader = Loadable.Map({
	loader: {
		SetupComponent: () => import(/* webpackChunkName: "setup" */ "layout/Setup"),
		api: () => import(/* webpackChunkName: "setup" */ "lib/api/sevenTwenty.js"),
		customLogo: () => import(/* webpackChunkName: "setup" */ "assets/images/svg/calibrate.svg"),
		projectTheme: () => import(/* webpackChunkName: "setup" */ "config/projectVars/sevenTwenty.js"),
	},
	loading: Loading,
	render(loaded, props) {
		const Setup = loaded.SetupComponent.default;
		const api = loaded.api.default;
		const logo = loaded.customLogo.default;
		const theme = loaded.projectTheme.default;
		return <Setup api={api} customLogo={logo} projectTheme={theme} />;
	},
});

const SevenTwentyUSCCLoader = Loadable.Map({
	loader: {
		SetupComponent: () => import(/* webpackChunkName: "setup" */ "layout/Setup"),
		api: () => import(/* webpackChunkName: "setup" */ "lib/api/sevenTwenty_uscc.js"),
		customLogo: () => import(/* webpackChunkName: "setup" */ "assets/images/svg/calibrate.svg"),
		projectTheme: () => import(/* webpackChunkName: "setup" */ "config/projectVars/sevenTwenty.js"),
	},
	loading: Loading,
	render(loaded, props) {
		const Setup = loaded.SetupComponent.default;
		const api = loaded.api.default;
		const logo = loaded.customLogo.default;
		const theme = loaded.projectTheme.default;
		return <Setup api={api} customLogo={logo} projectTheme={theme} />;
	},
});

const CraftsmanSetupLoader = Loadable.Map({
	loader: {
		SetupComponent: () => import(/* webpackChunkName: "setup" */ "layout/Setup"),
		api: () => import(/* webpackChunkName: "setup" */ "lib/api/craftsmanApi.js"),
	},
	loading: Loading,
	render(loaded, props) {
		const Setup = loaded.SetupComponent.default;
		const api = loaded.api.default;
		return <Setup api={api} />;
	},
});

const UsipSetupLoader = Loadable.Map({
	loader: {
		SetupComponent: () => import(/* webpackChunkName: "setup" */ "layout/Setup"),
		api: () => import(/* webpackChunkName: "setup" */ "lib/api/usipApi.js"),
	},
	loading: Loading,
	render(loaded, props) {
		const Setup = loaded.SetupComponent.default;
		const api = loaded.api.default;
		return <Setup api={api} />;
	},
});

const IraqSetupLoader = Loadable.Map({
	loader: {
		SetupComponent: () => import(/* webpackChunkName: "setup" */ "layout/Setup"),
		api: () => import(/* webpackChunkName: "setup" */ "lib/api/iraqApi.js"),
	},
	loading: Loading,
	render(loaded, props) {
		const Setup = loaded.SetupComponent.default;
		const api = loaded.api.default;
		return <Setup api={api} />;
	},
});

const VenezuelaSetupLoader = Loadable.Map({
	loader: {
		SetupComponent: () => import(/* webpackChunkName: "setup" */ "layout/Setup"),
		api: () => import(/* webpackChunkName: "setup" */ "lib/api/venezuelaApi.js"),
	},
	loading: Loading,
	render(loaded, props) {
		const Setup = loaded.SetupComponent.default;
		const api = loaded.api.default;
		return <Setup api={api} />;
	},
});

// Same as VenezuelaSetupLoader, except with a customLogo
const SayaraSetupLoader = Loadable.Map({
	loader: {
		SetupComponent: () => import(/* webpackChunkName: "setup" */ "layout/Setup"),
		customLogo: () => import(/* webpackChunkName: "setup" */ "assets/images/double_logo.png"),
		api: () => import(/* webpackChunkName: "setup" */ "lib/api/venezuelaApi.js"),
	},
	loading: Loading,
	render(loaded, props) {
		const Setup = loaded.SetupComponent.default;
		const api = loaded.api.default;
		const logo = loaded.customLogo.default;
		return <Setup api={api} customLogo={logo} />;
	},
});

const SetupLoader = (props) => {
	// console.log("SetupLoader", props.currentProject);
	return props.currentProject === "texas23" ? (
		<UsccSetupLoader />
	) : props.currentProject === "cbp" ? (
		<CBPSetupLoader />
	) : props.currentProject === "balticsDemo" ? (
		<BalticsDemoSetupLoader />
	) : props.currentProject === "bcbs" ? (
		<BCBSSetupLoader />
	) : props.currentProject === "dccc" ? (
		<DcccSetupLoader />
	) : props.currentProject === "gec" ? (
		<GECSetupLoader />
	) : props.currentProject === "gec_analyst" ? (
		<GECAnaystSetupLoader />
	) : props.currentProject === "gec_dev" ? (
		<GECDevSetupLoader />
	) : props.currentProject === "iraq" ? (
		<IraqSetupLoader />
	) : props.currentProject === "craftsman" ? (
		<CraftsmanSetupLoader />
	) : props.currentProject === "usip" ? (
		<UsipSetupLoader />
	) : props.currentProject === "sevenTwenty" ? (
		<SevenTwentyLoader />
	) : props.currentProject === "sevenTwenty_uscc" ? (
		<SevenTwentyUSCCLoader />
	) : props.currentProject === "midterms" ? (
		<MidtermsSetupLoader />
	) : props.currentProject === "venezuela" ? (
		<VenezuelaSetupLoader />
	) : props.currentProject === "sayara" ? (
		<SayaraSetupLoader />
	) : (
		<DemoSetupLoader />
	);
};

export default SetupLoader;
